import {StoreSetting} from "../model/store-setting";
import {FirebaseService} from '../services/firebase.service';

export class StoreSettingUtil {
  static storeSetting: StoreSetting;

  static onReadStoreSetting(firebaseService: FirebaseService, storeId: string, callback?: (data: StoreSetting) => void) {
    if (this.storeSetting) {
      if (callback) {
        callback(this.storeSetting);
      }
    }

    if (storeId) {
      firebaseService.onGetDataValueChanges(FirebaseService.storeSetting, storeId).subscribe((value) => {
        if (value) {
          const storeSetting = new StoreSetting();
          storeSetting.formJson(value as any);
          this.storeSetting = storeSetting;
          if (callback) {
            callback(storeSetting);
          }
        }
      });
    }
  }

  static getEmailSetting() {
    try {
      return this.storeSetting.emailSetting;
    } catch (e) {
      return null;
    }
  }

  static getCurrencyExchange() {
    try {
      if (this.storeSetting && this.storeSetting.currencyExchanges) {
        const ex = this.storeSetting.currencyExchanges[0];
        if (ex.from === "USD") {
          return ex;
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  static isSecondaryCurrencyHasData(storeId: string): boolean {
    try {
      return !!this.getCurrencyExchange();
    } catch (e) {
      return false;
    }
  }

  static clear(){
    this.storeSetting = undefined;
  }
}
